import { ProductType } from '@inter-ikea-storageone/range';
import platform from 'rangeConfig/shared/utils/platform';
import { ProductListConfig } from 'rangeConfig/@types';
import {
  matchDesign,
  matchInteriorsToFrames
} from 'rangeConfig/pax/filters/mainMenuProductFilters';
import addSingleInterior from 'rangeConfig/shared/behaviors/addSingleInterior';

const productFilters = {
  desktop: [matchInteriorsToFrames],
  mobile: [matchInteriorsToFrames, matchDesign]
};

const interiorsProductListConfig: ProductListConfig = {
  cardsTitle: '',
  cardsSubtitle: ' ',
  infoButtonAriaLabel:
    'typeName, communicatedDimensionsLocalized.width communicatedDimensionsLocalized.unit storageone.productCardTextWide',
  behaviors: {
    productClicked: [addSingleInterior],
    productDropped: [addSingleInterior]
  },
  productFilters: productFilters[platform],
  cluster: ['design', 'type'],
  sortOrder: [],
  categories: [
    {
      id: 'interiors',
      cardsSubtitle: 'typeName, designText',
      products: [
        { path: 'type', value: ProductType.PAX_CLOTH_RAIL_350 },
        { path: 'type', value: ProductType.PAX_CLOTH_RAIL_580 }
      ],
      cluster: ['design', 'type', 'dimensions.depth']
    },
    {
      id: 'interiors',
      cardsSubtitle: 'typeName, designText',
      products: [
        { path: 'type', value: ProductType.PAX_SHELF },
        { path: 'type', value: ProductType.PAX_GLASS_SHELF }
      ]
    },

    {
      id: 'interiors',
      cardsSubtitle: 'typeName, designText',
      products: [
        { path: 'type', value: ProductType.PAX_PULL_OUT_TRAY },
        { path: 'type', value: ProductType.PAX_PULL_OUT_TRAY_WITH_DIVIDER_INSERTS_ASM },
        { path: 'type', value: ProductType.PAX_PULL_OUT_TRAY_WITH_COMPARTMENT_INSERTS_ASM },
        { path: 'type', value: ProductType.PAX_PULL_OUT_TRAY_WITH_MAT_ASM }
      ]
    },
    {
      id: 'interiors',
      cardsSubtitle: 'typeName, designText',
      products: [{ path: 'type', value: ProductType.PAX_PULL_OUT_TROUSER_HANGER }]
    },
    {
      id: 'interiors',
      cardsSubtitle: 'typeName, designText',
      products: [
        { path: 'type', value: ProductType.PAX_DRAWER },
        { path: 'type', value: ProductType.PAX_GLASS_DRAWER },
        { path: 'type', value: ProductType.PAX_DRAWER_FRAMED },
        { path: 'type', value: ProductType.PAX_DRAWER_FRAMED_GLASS },
        { path: 'type', value: ProductType.PAX_DRAWER_LOCKABLE },
        { path: 'type', value: ProductType.PAX_MESH_BASKET_ASM },
        { path: 'type', value: ProductType.PAX_METAL_BASKET_ASM }
      ]
    },
    {
      id: 'interiors',
      cardsSubtitle: 'typeName, designText',
      products: [
        { path: 'type', value: ProductType.PAX_PULL_OUT_TRAY_WITH_SHOE_INSERTS_ASM },
        { path: 'type', value: ProductType.PAX_SHOE_SHELF },
        { path: 'type', value: ProductType.PAX_PULL_OUT_SHOE_SHELF }
      ]
    },
    {
      id: 'interiors',
      cardsSubtitle: 'typeName, designText',
      products: [{ path: 'type', value: ProductType.PAX_CLEANING_INTERIOR }]
    },
    {
      id: 'interiors',
      cardsSubtitle: 'typeName, designText',
      products: [
        { path: 'type', value: ProductType.PAX_PULL_OUT_MULTI_USE_HANGER },
        { path: 'type', value: ProductType.PAX_VALET_HANGER }
      ]
    },
    {
      id: 'interiors',
      cardsSubtitle: 'typeName, designText',
      products: [
        { path: 'type', value: ProductType.PAX_L_DIVIDER },
        { path: 'type', value: ProductType.PAX_T_DIVIDER }
      ]
    }
  ]
};

export default interiorsProductListConfig;
